/** These class will get called whenever any event is occured in UI
,to check if there is any rule matching to the action**/
import { Injectable } from "@angular/core"
import { HelpersService } from "../helpers/helpers.service";
import { LWRuleEvaluator } from "./lw-rule-evaluator";
import { CommonService } from "./common.service";
import * as _ from 'lodash';
@Injectable({
    providedIn:'root'
})
export class LWUIRuleEngine{

    data:any = {};
    shouldExecuteAction:boolean = false;
    expressionStack:any = [];
    err:string = "Error occured while Configuring Rules";
    /**Execute is the main method
       it take event name and data associated to it as parameter**/
    constructor(
        private _helpers:HelpersService,
        private LWRuleEvaluator:LWRuleEvaluator,
        private _commonService:CommonService
    ){}
    execute(workflow, data,service, cb) {
        this.data = data;
        this.shouldExecuteAction = false;
        this.expressionStack = [];
        this.err = "Error occured while Configuring Rules";
        // This will contains all the actions which needs to be performed
        var mandatoryActionsToPerform = [];
        var mandatoryActionsMap = {};
        var notesParameter = {};

        if (workflow && workflow.length) {
            var workflowPromises:any = [];
            for (var ruleCount = 0; ruleCount < workflow.length; ruleCount++) {
                this.expressionStack = [];
                this.shouldExecuteAction = false;

                if (workflow[ruleCount].hasOwnProperty('conditions') && workflow[ruleCount].conditions.length > 0) {
                    _.each(workflow[ruleCount].conditions, (condition)=> {
                        this.LWRuleEvaluator.evaluateConditions(this.data, condition, (err, conditionResult)=> {
                            if (!err) {
                                var topElement = this.expressionStack.pop()
                                if (topElement != undefined && topElement != null && typeof topElement != 'boolean') {
                                    var leftOperand = this.expressionStack.pop(); //get first operand

                                    //it will evaluate the join of first condition with ouput of second condition and return true/false.
                                    this.shouldExecuteAction =  this.LWRuleEvaluator.solveExpression(leftOperand, conditionResult, topElement)
                                    this.expressionStack.push(this.shouldExecuteAction);
                                } else {
                                    this.expressionStack.push(conditionResult); //push it to stack as its not an operator.
                                }
                                if (condition.hasOwnProperty('join_id')) {
                                    this.expressionStack.push(condition.join_id); //push join_id('$and','$or') to expression stack
                                } else {
                                    console.log("Join Operator not found for the condition-" + JSON.stringify(condition));
                                    this.expressionStack.push("null")
                                }
                            } else {
                                console.log("Error occured while evaluating conditions",JSON.stringify(err))
                                cb("LW_UI_RULE:Error occured while evaluating conditions", null);
                                return;
                            }
                        })
                    })

                    if (this.expressionStack.length == 2) {
                        // var $q = angular.element(document.body).injector().get('$q')
                        this.expressionStack.pop();
                        this.shouldExecuteAction = this.expressionStack.pop();
                        if (!this.shouldExecuteAction) {
                            console.warn("No condition matched. Dont perform any action");
                        } else {
                            if (workflow[ruleCount].hasOwnProperty('actions') && workflow[ruleCount].actions.length > 0) {
                                var params = {};

                                if (workflow[ruleCount].actions[0]) {
                                    //type 1 is basically used for actions related to custom_field_renderer.Later it got depricated and
                                    // type 2 will be used for all coming actions in future.
                                    if (workflow[ruleCount].actions[0].type == 1 || !workflow[ruleCount].actions[0].type) {

                                        /** This block is for Mandatory Rules: OpenPopup
                                         *   Comment out the below code: 
                                         *   Instead, maintaining array which will contains all the actions to be performed.
                                         *   Will process them all in the end
                                         */

                                        if (_.get(workflow, ruleCount + ".actions.0.action") == "openLWNotes") {
                                            notesParameter['issueDetail'] = data;
                                            notesParameter['issueId'] = data._id;
                                            notesParameter['brandDetail'] = this.data.brandDetail;
                                            notesParameter['action'] = workflow[ruleCount].actions[0];
                                            notesParameter['selectedStatus'] = data.status_id_list;
                                        } else {
                                            if (_.get(workflow, ruleCount + ".actions.0.options.group_id")) {
                                                // To avoid Duplicate Data
                                                if (!mandatoryActionsMap[workflow[ruleCount].actions[0].options.group_id]) {
                                                    mandatoryActionsToPerform = mandatoryActionsToPerform.concat(workflow[ruleCount].actions[0]);
                                                    mandatoryActionsMap[workflow[ruleCount].actions[0].options.group_id] = true;
                                                }
                                            }
                                        }
                                    } else if (workflow[ruleCount].actions[0].type == 2 && workflow[ruleCount].actions[0].action) {
                                        /**
                                         * To make it generic and reduce complexity we have introduced type 2 which will be used for
                                         * all the actions other than custom field renderer.Type 1 is the depricated one.
                                         */
                                        var actionClassName = workflow[ruleCount].actions[0].action;
                                        params['action'] = workflow[ruleCount].actions[0];
                                        params['data'] = data;
                                        //creating instance of class dynamically
                                        // todo::::
                                        console.log("actionClassName",actionClassName)
                                        // var actionInstance = new window[actionClassName](params);
                                        // var promise = $q.defer();
                                        // workflowPromises.push(actionInstance._execute(promise));
                                    } else {
                                        console.warn("LW-UI-RULE:Invalid Action Setup")
                                        cb("LW-UI-RULE:Invalid Action Setup", null);
                                        return;
                                    }
                                }
                            } else {
                                console.log("No conditions in rule")
                                cb("No conditions in rule", null);
                                return;
                            }
                        }
                    } else {
                        console.log("Error:LW-UI-RULE-condition setup is not proper.")
                        cb(this.err, null);
                    }
                } else {
                    console.log("No conditions found within the rule");
                    return cb(null, null);
                }


            }
            var errorList:any = [];
            try {
                /**
                 * Notes: Notes can't be clubbed with dynamic accordion. 
                 * If there are mandatory rules for the accordion along with the Mandatory Notes. The priority will be for Accordion
                 */
                // mandatoryActionsToPerform: This will contains all the Mandatory Actions: OpenPopup cases for single or multiple accordion
                // if (_.get(mandatoryActionsToPerform, "length")) {
                //     var paramsForMandatoryRule = prepareParamForMandatoryRule(mandatoryActionsToPerform, this.data.brandDetail, data)
                //     var ltmsCustomField = new LtmsCustomFieldRenderer(paramsForMandatoryRule, $scope);
                //     var promise = $q.defer();
                //     workflowPromises.push(ltmsCustomField._renderAction(promise));
                // } else if (!_.isEmpty(notesParameter)) {
                //     var ltmsCustomField = new LtmsCustomFieldRenderer(notesParameter, $scope);
                //     var promise = $q.defer();
                //     workflowPromises.push(ltmsCustomField._renderAction(promise));
                // }

                // var paramsForMandatoryRule = prepareParamForMandatoryRule(mandatoryActionsToPerform, this.data.brandDetail, data);
                // console.log("\n ------------------------------------------------- \n");
                // console.log("Before paramsForMandatoryRule::::", paramsForMandatoryRule);

                var params = {};
                if (_.get(mandatoryActionsToPerform, "0.options.group_id") == "ltms_custom_field_siblings") {
                    params = {
                        "issueDetail": data,
                        "issueId": data._id,
                        "brandDetail": this.data.brandDetail,
                        "action": mandatoryActionsToPerform[0],
                        "selectedStatus": data.status_id_list
                    }
                } else if (_.get(mandatoryActionsToPerform, "length") && !_.isEmpty(notesParameter)) {
                    params = this.prepareParamForMandatoryRule(mandatoryActionsToPerform, this.data.brandDetails, data, true);
                    this.prepareNotesParamForMultipleAccordion(params, notesParameter);
                } else if (_.get(mandatoryActionsToPerform, "length")) {
                    params = this.prepareParamForMandatoryRule(mandatoryActionsToPerform, this.data.brandDetails, data);
                } else if (!_.isEmpty(notesParameter)) {
                    params = notesParameter;
                }

                if (!_.isEmpty(params)) {
                    console.log("dasdfasdfad executer custom field render",params)
                    // need to implement
                    // var ltmsCustomField = new LtmsCustomFieldRenderer(params, $scope);
                    // var promise = $q.defer();
                    workflowPromises.push( this._commonService.renderCustomFieldsWithAction(params,service));
                }

                Promise.all(workflowPromises).then(function(promiseData) {
                    _.each(promiseData, function(d:any) {
                        if (d.error) {
                            errorList.push(d.error);
                        }
                    })
                    if (!(errorList && errorList.length)) {
                        return cb(null, promiseData);
                    } else {
                        return cb(errorList, null);
                    }
                })
            } catch (e) {
                console.log("Exeception occured: ", e)
                return cb(null, [])
            }

        } else {
            console.warn("No UI Rules are configured in the Brand");
            return cb(null, true);
        }
    }

    prepareNotesParamForMultipleAccordion(mandatoryParameters, notesParameter) {
        var parametersToUpdate = _.get(mandatoryParameters, "brandDetail.field_definitions")
        // Prepare Notes Parameter and update it into mandatory Actions
        parametersToUpdate.push({
            "name": "Notes",
            "display_name": "",
            "data_category": "",
            "data_type": "header",
            "dom_options": {
                "required": false,
                "label": false
            },
            "show_in_inbox_detail": true,
            "custom_parameter_type": 4,
            "group_id": "ltms_multiple_accordion_fields",
            "seq_no": 101,
            "field_id": "header_for_notes",
            "is_single_request_initiation": false
        });

        parametersToUpdate.push({
            "name": "Notes",
            "display_name": "Notes",
            "data_category": "profile_data",
            "data_type": "string",
            "dom_options": {
                "type": "multi-line",
                "rows": "3",
                "required": true
            },
            "show_in_inbox_detail": true,
            "custom_parameter_type": 4,
            "group_id": "ltms_multiple_accordion_fields",
            "seq_no": 102,
            "field_id": "ltms_custom_field_rca_notes",
            "is_single_request_initiation": false
        });

        // Remove notes in case of Multiple Mandatory Rule. As it has to be filled by the user dynamically. There is no prefilled data required at this point of time.
        if (_.get(mandatoryParameters, "issueDetail.tags.ltms_custom_field_rca_notes")) {
            mandatoryParameters.issueDetail.tags.ltms_custom_field_rca_notes = null;
        }
        console.log("mandatoryParameters::::", parametersToUpdate);
        console.log("notesParameter::::", notesParameter);
        console.log("\n ------------------------------------------------- \n");
    }

    prepareParamForMandatoryRule(mandatoryActionsToPerform, brandDetail, data, hasNotes?:boolean) {
        var tempFieldDefinitions:any = [];
        var groupSubFieldDefinitions:any = [];
        var fieldDefinitionsByGroup:any = [];
        var parentGroup:any = [];
        var popupHeader = "";
        var noOfAccordions = mandatoryActionsToPerform.length;
        var groupId = null;

        // Prepare parameters to be rendered on popup
        var paramsForMandatory = {
            issueDetail: data,
            issueId: data._id,
            brandDetail: brandDetail,
            action: {
                "action": "openPopup",
                "options": {
                    "group_id": "ltms_multiple_accordion_fields" // Provide a temp Id
                }
            },
            selectedStatus: data.status_id_list
        };

        // Loop through all the mandatory rules and fetch field_definfitons based on the rules
        _.each(mandatoryActionsToPerform, (parameter, index) =>{
            groupId = _.get(parameter, "options.group_id");
            fieldDefinitionsByGroup = _.filter(paramsForMandatory["brandDetail"]["field_definitions"], { "group_id": groupId });
            parentGroup = _.filter(paramsForMandatory["brandDetail"]["field_definitions"], { "field_id": groupId });
            var groupTypeFields = _.filter(fieldDefinitionsByGroup, { "data_type": "group" })

            // Add seperator in case of multiple accordions
            if (noOfAccordions > 1 || hasNotes) {
                fieldDefinitionsByGroup.unshift({
                    "name": _.get(parentGroup, "0.name") || "",
                    "display_name": "",
                    "data_category": "",
                    "data_type": "header",
                    "dom_options": {
                        "required": false,
                        "label": false
                    },
                    "show_in_inbox_detail": true,
                    "custom_parameter_type": 4,
                    "group_id": "ltms_multiple_accordion_fields",
                    "seq_no": 1,
                    "field_id": "header_" + groupId,
                    "is_single_request_initiation": false
                })

                popupHeader = "Please provide the following details before proceeding";
            } else {
                if (_.get(parentGroup, "0.name")) {
                    popupHeader += (parentGroup[0]["name"] + (((noOfAccordions - 1) == index) ? " " : ", "));
                }
            }

            // Merge all the field definitions which needs to be rendered all at once
            if (groupTypeFields && groupTypeFields.length) {
                _.each(groupTypeFields, (field_definition) =>{
                    if (field_definition && field_definition.dom_options && field_definition.dom_options.group_to_render) {
                        var data = _.filter(paramsForMandatory["brandDetail"]["field_definitions"], { "group_id": field_definition.dom_options.group_to_render });
                        if (data && data.length) {
                            groupSubFieldDefinitions = groupSubFieldDefinitions.concat(data)
                        }
                    }
                })
            }

            tempFieldDefinitions = tempFieldDefinitions.concat(fieldDefinitionsByGroup);
        });

        this._helpers.getLoggedInAccessLevel((accessLevel)=> {
            // update field_definition's group Id so that multiple group can be rendered at same time
            _.each(tempFieldDefinitions, (fieldDefinition, index)=> {
                fieldDefinition["seq_no"] = (index + 1);
                fieldDefinition["group_id"] = "ltms_multiple_accordion_fields";
            })
        })
        tempFieldDefinitions = tempFieldDefinitions.concat(groupSubFieldDefinitions);
        // Push a temp parent group 
        tempFieldDefinitions.push({
            "name": popupHeader,
            "custom_parameter_type": 4,
            "group_id": null,
            "field_id": "ltms_multiple_accordion_fields",
            "show_in_inbox_detail": true,
            "is_single_request_initiation": false
        })
        paramsForMandatory["brandDetail"]["field_definitions"] = tempFieldDefinitions;

        return paramsForMandatory;
    }
}